import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout, type LegalSection } from "@/components/legal/legal-layout";
import { usePolicy } from "@/lib/policies-store";
import { renderPolicyBody } from "@/lib/render-policy";
import { useLocalizedPolicy } from "@/lib/use-localized-policy";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms & conditions — Spayzo" },
      {
        name: "description",
        content:
          "Read the terms and conditions governing bookings, payments, host listings and account use on the Spayzo hourly space booking platform.",
      },
      { property: "og:title", content: "Terms & conditions — Spayzo" },
      { property: "og:description", content: "Read the terms that apply to all users of Spayzo." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://spayzo.lovable.app/terms" }],
  }),
  component: TermsPage,
});

function TermsPage() {
  const doc = useLocalizedPolicy("terms", usePolicy("terms"));
  const sections: LegalSection[] = doc.sections.map((s) => ({
    id: s.id,
    title: s.title,
    body: renderPolicyBody(s.body),
  }));
  return (
    <LegalLayout
      title={doc.title}
      description={doc.description}
      updated={doc.updated}
      sections={sections}
      numbered={doc.numbered}
    />
  );
}
